import React, { useEffect, useRef, useState } from "react";

import videojs from 'video.js'
import 'video.js/dist/video-js.css';

import styles from './audioPlayer.module.scss'
import translation from "../../../../Components/Helpers/translation";
import { PlayImage, StopImage } from "../../../../assets/images/general/svg";
import { NoteBigImage } from "../../../../assets/images/svg";

function AudioPlayer({ data = null, index, setCurrentPlayingIndex, currentPlayingIndex }) {
    const [isPlaying, setIsPlaying] = useState(false)
    const [durationPart, setDurationPart] = useState(0)
    const videoPlayerRef = useRef()
    const playerRef = React.useRef(null)
    const loadingRef = useRef()
    const isButton = true

    const togglePlay = () => {
        let player = playerRef.current;

        if (!player) {
            setIsPlaying(true);
            setCurrentPlayingIndex(index)

            let playerSet = playerRef.current = videojs(videoPlayerRef.current, {}, () => {
                if (data)
                    playerSet.src(`https://storage.nifc.pl/web_files/_plik/discography/recordings/${data.id_old_recordings}/${data.file_mp3}`)
                // playerSet.src(`https://storage.nifc.pl/web_files/_plik/discography/recordings/2990/01_Chopin-_Prelude_in_A_flat_-_Presto_Con_Leggierezza.mp3`)
            })

            if (playerSet.readyState() < 1) {
                playerSet.one("loadedmetadata", onLoadedMetadata);
                playerSet.one("play", onplay)
                playerSet.one("pause", onpause)
                playerSet.one("stop", onstop)
                playerSet.on('timeupdate', timeupdate);
            }

            function onLoadedMetadata() {
                if (parseInt(videoPlayerRef.current.dataset.curentindex) === index) {
                    playerSet.play()
                }
            }

            function onplay() {
                setIsPlaying(true);
            }

            function onpause() {
                setIsPlaying(false);
            }

            function onstop() {
                setIsPlaying(false);
            }

            function timeupdate() {
                setDurationPart((playerSet.currentTime() / playerSet.duration() * 100).toFixed(5));
                if (playerSet.currentTime() === playerSet.duration()) {
                    setIsPlaying(false);
                }
            }

            return () => {
                playerSet.dispose();
            }
        } else {
            setIsPlaying(!isPlaying);
            if (isPlaying) {
                player.pause()
            } else {
                player.play()
                setCurrentPlayingIndex(index)
            }
        }
    }

    useEffect(() => {


        if (playerRef.current) {
            let player = playerRef.current;
            if (index !== currentPlayingIndex) {
                setIsPlaying(false)
                player.pause()
            }
        }
    }, [currentPlayingIndex, index])

    return (
        <>
            {isButton ?
                <>
                    <video ref={videoPlayerRef} className="video-js" controls style={{ display: "none" }} data-curentindex={currentPlayingIndex} />
                    <button
                        type={'button'}
                        className={`${styles.button} ${isPlaying ? styles.active : ''}`}
                        onClick={(event) => togglePlay(event)}
                        aria-label={translation.all.playPause}
                        title={translation.all.playPause}
                    >
                        <svg width="100%" height="100%" viewBox={`0 0 32 32`} className={styles.playTimeChart}>
                            <circle r="25%" cx="50%" cy="50%" style={{ strokeDasharray: `${durationPart / 2}, 100` }} />
                        </svg>
                        <div className={`${styles.symbol} ${styles.symbolPlay}`}>
                            <PlayImage />
                        </div>
                        <div className={`${styles.symbol} ${styles.symbolStop}`}>
                            <StopImage />
                        </div>
                        <div ref={loadingRef} className={`${styles.symbol} ${styles.symbolLoading}`} />
                    </button>
                </>
                : <NoteBigImage />
            }
        </>
    )
}

export default AudioPlayer